export const TILE_SIZE = 32 // Logical game tile (for tower placement, collision, etc.)
export const SUBTILE_SIZE = 16 // Render subtile (native sprite size)
export const GRID_WIDTH = 36 // tiles (doubled for 32px tiles)
export const GRID_HEIGHT = 60 // tiles (doubled for 32px tiles)
export const SUBTILE_GRID_WIDTH = GRID_WIDTH * 2 // 72 subtiles
export const SUBTILE_GRID_HEIGHT = GRID_HEIGHT * 2 // 120 subtiles
export const WORLD_WIDTH = GRID_WIDTH * TILE_SIZE // 1152px (same world size)
export const WORLD_HEIGHT = GRID_HEIGHT * TILE_SIZE // 1920px (same world size)
export const VIEWPORT_WIDTH = 576 // visible area width
export const VIEWPORT_HEIGHT = 960 // visible area height

export const gameSettings = {
  canvas: {
    width: WORLD_WIDTH,
    height: WORLD_HEIGHT,
    viewportWidth: VIEWPORT_WIDTH,
    viewportHeight: VIEWPORT_HEIGHT,
    tileSize: TILE_SIZE,
    gridWidth: GRID_WIDTH,
    gridHeight: GRID_HEIGHT,
  },
  fps: 60,
  gameSpeed: 1,
  colors: {
    background: "#3c5e2b",
    path: "#4a4032",
    ui: {
      money: "#ffff99",
      lives: "#ff8888",
      wave: "#ffffff",
    },
    placement: {
      valid: "rgba(0, 255, 0, 0.3)",
      invalid: "rgba(255, 0, 0, 0.3)",
    },
  },
  projectile: {
    defaultLifetime: 120,
    defaultSize: 5,
    towerColor: "#ffff33",
    enemyColor: "#ff5555",
    heroColor: "#00ff00",
  },
  ui: {
    healthBarHeight: 4,
    healthBarWidth: 30,
    minimapMaxHeight: 128,
    portraitSize: 64,
    bottomBarPadding: 8,
  },
}

export const constants = {
  TOWER_SELECTION_RADIUS: 25,
  HERO_SELECTION_RADIUS: 35, // Increased to prevent accidental build menu opens
  COLLISION_BUFFER: 5,
  MIN_CLICK_DISTANCE: 5,
  INTEREST_RATE: 0.05,
}

// Enemy aggro system constants
export const ENEMY_AGGRO_RADIUS = 100 // Default aggro radius in pixels (slightly less than 120px barracks rally radius)
export const ENEMY_AGGRO_COMMIT_MS = 2000 // Minimum chase commitment time in ms
export const ENEMY_AGGRO_COOLDOWN_MS = 1000 // Cooldown after returning to path before can re-aggro
export const ENEMY_RETURN_SPEED_MULT = 1.5 // Speed multiplier when returning to path
export const ENEMY_MAX_PATH_DISTANCE = 100 // Max distance from path before forced return

// Enemy progression scaling constants (based on starmap nodes completed)
export const ENEMY_PROGRESSION_MAX = 7 // Maximum progression level bonus (+7)
export const ENEMY_PROGRESSION_STAT_MULT = 1.07 // 7% stat increase per progression level (compound)
export const ENEMY_PROGRESSION_ARMOR_INTERVAL = 3 // +1 armor every 3 progression levels

// Item pickup constants
export const ITEM_PICKUP_RANGE = 200 // Hero must be within 200px to pick up items
